import type { OrganizationType, SubscriptionType } from '@form-factory/schema';
import { formatUtils } from '@form-factory/shared';
import { Trans, useLingui } from '@lingui/react/macro';
import { cn, Progress } from '@utima/ui';

export function UsageMetricsDisplay({
  organization,
  subscription,
}: {
  organization: OrganizationType;
  subscription: SubscriptionType | null;
}) {
  const { t } = useLingui();
  const orgCurrency = organization.currency;

  // const currentUsage = organization.currentMonthlyUsage ?? 0;
  // const usageLimit = organization.monthlyUsageLimit ?? 0;

  // const allowanceUsed = Math.min(currentUsage, usageLimit);
  // const allowancePercent =
  //   usageLimit > 0 ? (allowanceUsed / usageLimit) * 100 : 0;
  const balance = organization.balance ?? 0;

  const showAutoRenewalLimit =
    subscription?.autoRenewal &&
    typeof subscription.autoRenewalLimit === 'number' &&
    subscription.autoRenewalLimit >= 0;
  const autoRenewalCharged = subscription?.autoRenewalChargedThisPeriod ?? 0;
  const autoRenewalLimit = subscription?.autoRenewalLimit ?? 0;
  const autoRenewalPercent =
    showAutoRenewalLimit && autoRenewalLimit > 0
      ? (autoRenewalCharged / autoRenewalLimit) * 100
      : 0;

  return (
    <section className='flex flex-col gap-4 text-sm'>
      {/* Allowance Section */}
      {/* {subscription?.status === SubscriptionStatus.Active && (
        <div>
          <div className='mb-1 flex justify-between'>
            <span className='text-gray-700'>
              <Trans>Monthly Allowance Used</Trans>
            </span>
            <span className='font-medium'>
              {formatUtils.credits(allowanceUsed, orgCurrency)} /{' '}
              {formatUtils.credits(usageLimit, orgCurrency)}
            </span>
          </div>
          <Progress
            value={allowancePercent}
            className='h-2'
            aria-label={t`Monthly allowance usage: ${allowancePercent.toFixed(0)}%`}
          />
        </div>
      )} */}

      {/* Balance Section */}
      <div>
        <div className='flex justify-between'>
          <span className='text-gray-700'>
            <Trans>Prepaid Balance Remaining</Trans>
          </span>
          <span
            className={cn(
              'font-medium',
              balance < 0 ? 'text-red-500' : 'text-green-600',
            )}
          >
            {formatUtils.credits(balance, orgCurrency)}
          </span>
        </div>
      </div>

      {/* Auto-Renewal Limit Section (Conditional) */}
      {showAutoRenewalLimit && (
        <div className='mt-3 border-t'>
          <div className='mb-1 flex justify-between'>
            <span className='text-gray-700'>
              <Trans>Auto-Renewal Spending Limit</Trans>
            </span>
            <span className='text-xs text-gray-500'>
              <Trans>(Current Period)</Trans>
            </span>
          </div>
          <Progress
            value={autoRenewalPercent}
            className='h-2'
            aria-label={t`Auto-renewal spending this period: ${autoRenewalPercent.toFixed(0)}%`}
          />
          <div className='mt-1 text-right text-xs text-gray-500'>
            <Trans>
              {formatUtils.credits(autoRenewalCharged, orgCurrency)} used of{' '}
              {formatUtils.credits(autoRenewalLimit, orgCurrency)} monthly limit
            </Trans>
          </div>
        </div>
      )}

      {/* Helper Text */}
      {/* <div className='flex items-center text-xs text-gray-500'>
        <Info size={14} className='mr-1.5 shrink-0' />
        <span>
          <Trans>
            Usage costs deplete your monthly allowance first, then your prepaid
            balance.
          </Trans>
        </span>
      </div> */}
    </section>
  );
}
